import serverProps from '../utils/serverProps'
import { ActionTypes as types } from '../constants'

const {
  recipientData: {
    showDonateAnonymousCheckbox = false,
    isRecurring = false,
    donationContext: { custom_data = '' } = {},
  } = {},
  locality: { country = '' } = {},
} = serverProps

const initialState = {
  showDonateAnonymousCheckbox,
  donationAnonymousStatus: custom_data === '0' ? 'checked' : '',
  country,
  isRecurring,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.EXTERNAL.CHANGE_DONATION_ANONYMOUS_STATUS:
      return {
        ...state,
        donationAnonymousStatus: action.data.donationAnonymousStatus,
      }
    default:
      return state
  }
}
